import * as types from './actionTypes';
import {api} from '../utility';



export function getBriefSucess(briefs) {
    return { type: types.BRIEF_SUCCESS, briefs};
}

export function getBrief(token){
    return function (dispatch, getState) {
      return fetch(api.BASE_URL + api.GET_BRIEFS, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
      },
    }).then(function(response) {
        return response.json();
    })
    .then(function(data) {
      if(data.error){
        throw data.error.message;
      }
      return dispatch(getBriefSucess(data));
    })
    .catch(function(error) {
      throw error;
    });
    };
  }